/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationResponsiblePersonRequest } from './ApplicationResponsiblePersonRequest';
import {
    ApplicationResponsiblePersonRequestFromJSON,
    ApplicationResponsiblePersonRequestFromJSONTyped,
    ApplicationResponsiblePersonRequestToJSON,
    ApplicationResponsiblePersonRequestToJSONTyped,
} from './ApplicationResponsiblePersonRequest';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { ApplicationStatus } from './ApplicationStatus';
import {
    ApplicationStatusFromJSON,
    ApplicationStatusFromJSONTyped,
    ApplicationStatusToJSON,
    ApplicationStatusToJSONTyped,
} from './ApplicationStatus';
import type { ApplicationMigrationStatus } from './ApplicationMigrationStatus';
import {
    ApplicationMigrationStatusFromJSON,
    ApplicationMigrationStatusFromJSONTyped,
    ApplicationMigrationStatusToJSON,
    ApplicationMigrationStatusToJSONTyped,
} from './ApplicationMigrationStatus';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface ApplicationUpdateRequest
 */
export interface ApplicationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUpdateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUpdateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUpdateRequest
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUpdateRequest
     */
    logoutUri?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    canIssueIdTokens?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    canIssueAccessTokens?: boolean;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof ApplicationUpdateRequest
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    isSearchableInMinSide?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {UserType}
     * @memberof ApplicationUpdateRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof ApplicationUpdateRequest
     */
    status?: ApplicationStatus;
    /**
     * 
     * @type {ApplicationMigrationStatus}
     * @memberof ApplicationUpdateRequest
     */
    migrationStatus?: ApplicationMigrationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    isIdPortenFederationDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    isStafFederationDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    requiresElevatedSecurityPolicy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUpdateRequest
     */
    canAppResponsiblesAppointExternalApprovers?: boolean;
    /**
     * 
     * @type {Array<ApplicationResponsiblePersonRequest>}
     * @memberof ApplicationUpdateRequest
     */
    responsiblePersons?: Array<ApplicationResponsiblePersonRequest> | null;
}



/**
 * Check if a given object implements the ApplicationUpdateRequest interface.
 */
export function instanceOfApplicationUpdateRequest(value: object): value is ApplicationUpdateRequest {
    return true;
}

export function ApplicationUpdateRequestFromJSON(json: any): ApplicationUpdateRequest {
    return ApplicationUpdateRequestFromJSONTyped(json, false);
}

export function ApplicationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'url': json['url'] === undefined ? undefined : json['url'] === null ? null : json['url'],
        'logoutUri': json['logoutUri'] === undefined ? undefined : json['logoutUri'] === null ? null : json['logoutUri'],
        'canIssueIdTokens': json['canIssueIdTokens'] == null ? undefined : json['canIssueIdTokens'],
        'canIssueAccessTokens': json['canIssueAccessTokens'] == null ? undefined : json['canIssueAccessTokens'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'isSearchableInMinSide': json['isSearchableInMinSide'] == null ? undefined : json['isSearchableInMinSide'],
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'status': json['status'] == null ? undefined : ApplicationStatusFromJSON(json['status']),
        'migrationStatus': json['migrationStatus'] == null ? undefined : ApplicationMigrationStatusFromJSON(json['migrationStatus']),
        'isIdPortenFederationDisabled': json['isIdPortenFederationDisabled'] == null ? undefined : json['isIdPortenFederationDisabled'],
        'isStafFederationDisabled': json['isStafFederationDisabled'] == null ? undefined : json['isStafFederationDisabled'],
        'requiresElevatedSecurityPolicy': json['requiresElevatedSecurityPolicy'] == null ? undefined : json['requiresElevatedSecurityPolicy'],
        'canAppResponsiblesAppointExternalApprovers': json['canAppResponsiblesAppointExternalApprovers'] == null ? undefined : json['canAppResponsiblesAppointExternalApprovers'],
        'responsiblePersons': json['responsiblePersons'] === undefined ? undefined : json['responsiblePersons'] === null ? null : ((json['responsiblePersons'] as Array<any>).map(ApplicationResponsiblePersonRequestFromJSON)),
    };
}

export function ApplicationUpdateRequestToJSON(json: any): ApplicationUpdateRequest {
    return ApplicationUpdateRequestToJSONTyped(json, false);
}

export function ApplicationUpdateRequestToJSONTyped(value?: ApplicationUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'url': value['url'],
        'logoutUri': value['logoutUri'],
        'canIssueIdTokens': value['canIssueIdTokens'],
        'canIssueAccessTokens': value['canIssueAccessTokens'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'isSearchableInMinSide': value['isSearchableInMinSide'],
        'requiresMfa': value['requiresMfa'],
        'userType': UserTypeToJSON(value['userType']),
        'status': ApplicationStatusToJSON(value['status']),
        'migrationStatus': ApplicationMigrationStatusToJSON(value['migrationStatus']),
        'isIdPortenFederationDisabled': value['isIdPortenFederationDisabled'],
        'isStafFederationDisabled': value['isStafFederationDisabled'],
        'requiresElevatedSecurityPolicy': value['requiresElevatedSecurityPolicy'],
        'canAppResponsiblesAppointExternalApprovers': value['canAppResponsiblesAppointExternalApprovers'],
        'responsiblePersons': value['responsiblePersons'] == null ? undefined : ((value['responsiblePersons'] as Array<any>).map(ApplicationResponsiblePersonRequestToJSON)),
    };
}

